import React, { useEffect, useState } from 'react';
import './History.css';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { FaTrashAlt, FaEye, FaPlus } from 'react-icons/fa';
import api from "../api";

export default function History() {
  const [sortOrder, setSortOrder] = useState('desc'); // For Reports
  const [appointmentSortOrder, setAppointmentSortOrder] = useState('desc'); // For Appointments
  const [reports, setReports] = useState([]);
  const [medications, setMedications] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [newMedication, setNewMedication] = useState('');
  const token = localStorage.getItem("token");

  useEffect(() => {
    api.get('/api/reports').then(res => {
      setReports(res.data.reports || []);
      const appointmentsOnly = res.data.reports.map(r => ({
        date: r.date,
        prescription: r.prescription_url
      }));
      setAppointments(appointmentsOnly);
    }).catch(console.error);
  }, [token]);

  useEffect(() => {
    const meds = JSON.parse(localStorage.getItem('medications')) || [];
    setMedications(meds);
  }, []);

  const addMedication = () => {
    if (newMedication.trim()) {
      const updated = [...medications, { id: Date.now(), name: newMedication }];
      setMedications(updated);
      localStorage.setItem('medications', JSON.stringify(updated));
      setNewMedication('');
    }
  };

  const deleteMedication = (id) => {
    const updated = medications.filter(med => med.id !== id);
    setMedications(updated);
    localStorage.setItem('medications', JSON.stringify(updated));
  };

  const deleteReport = async (id) => {
    try {
      await api.delete(`/api/reports/${id}`);
      setReports(prev => prev.filter(r => r.id !== id));
    } catch (err) {
      alert("Failed to delete report");
    }
  };

  const [openMenu, setOpenMenu] = useState(null);
  const toggleMenu = (index) => {
    setOpenMenu(prev => (prev === index ? null : index));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".menu-container")) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Sort both reports and appointments by date (format: DD/MM/YYYY)
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`);
  };

  const sortedReports = [...reports].sort((a, b) => {
    const dateA = parseDate(a.date);
    const dateB = parseDate(b.date);
    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });

  const sortedAppointments = [...appointments].sort((a, b) => {
    const dateA = parseDate(a.date);
    const dateB = parseDate(b.date);
    return appointmentSortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });

  return (
    <div className="history-page">
      <Header />
      <div className="history-body">
        <Sidebar />
        <div className="history-content">
          {/* Reports Table */}
          <h2>Reports:</h2>
          <table className="history-table">
            <thead>
              <tr>
                <th>#</th>
                {/* <th>Patient</th> */}
                <th
                  onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                  style={{ cursor: 'pointer' }}
                >
                  Date {sortOrder === 'asc' ? '↑' : '↓'}
                </th>
                <th>Report</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sortedReports.map((r, i) => (
                <tr key={r.id}>
                  <td>{i + 1}</td>
                  {/* <td>{r.full_name}</td> */}
                  <td>{r.date}</td>
                  <td>{r.report_url.split('/').pop()}</td>
                  <td className="menu-cell">
                    <div className="menu-container">
                      <button className="menu-button" onClick={() => toggleMenu(i)}>⋮</button>
                      {openMenu === i && (
                        <div className="dropdown-menu">
                          <a href={r.report_url} target="_blank" rel="noreferrer">View</a>
                          <button onClick={() => deleteReport(r.id)}>Delete</button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Medication Section */}
          <h2>Medication:</h2>
          <div className="medication-controls">
            <input
              type="text"
              placeholder="Add Medication"
              value={newMedication}
              onChange={(e) => setNewMedication(e.target.value)}
            />
            <button className="medication-button" onClick={addMedication}><FaPlus /></button>
          </div>
          <table className="history-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Medication</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {medications.map((med, i) => (
                <tr key={med.id}>
                  <td>{i + 1}</td>
                  <td>{med.name}</td>
                  <td><button className='delete-button' onClick={() => deleteMedication(med.id)}><FaTrashAlt /></button></td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Appointments Table */}
          <h2>Appointments:</h2>
          <table className="history-table">
            <thead>
              <tr>
                <th>#</th>
                <th
                  onClick={() =>
                    setAppointmentSortOrder(appointmentSortOrder === 'asc' ? 'desc' : 'asc')
                  }
                  style={{ cursor: 'pointer' }}
                >
                  Date {appointmentSortOrder === 'asc' ? '↑' : '↓'}
                </th>
                <th>Prescription PDF</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {sortedAppointments.map((a, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{a.date}</td>
                  <td>{a.prescription.split('/').pop()}</td>
                  <td>
                    <a href={a.prescription} target="_blank" rel="noreferrer"><FaEye /></a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}
